import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AssignmentComment } from '../models/project/assignment/comment/assignment-comment.interface';

@Injectable()
export class CommentService {
  private httpClient = inject(HttpClient);

  private commentsUrl = '';

  public setCommentsUrl(assignmentId: string) {
    this.commentsUrl = `${environment.apiUrl}/assignments/${assignmentId}/comments`;
  }

  public getAssignmentComments(): Observable<AssignmentComment[]> {
    return this.httpClient.get<AssignmentComment[]>(this.commentsUrl).pipe(
      catchError((error: unknown) => {
        throw new Error(`An error occurred: ${error}`);
      }),
    );
  }

  public createComment(message: string): Observable<AssignmentComment> {
    return this.httpClient
      .post<AssignmentComment>(this.commentsUrl, { message })
      .pipe(
        catchError((error: unknown) => {
          throw new Error(`An error occurred: ${error}`);
        }),
      );
  }

  public updateComment(id: string, message: string): Observable<null> {
    return this.httpClient
      .put<null>(`${this.commentsUrl}/${id}`, { message })
      .pipe(
        catchError((error: unknown) => {
          throw new Error(`An error occurred: ${error}`);
        }),
      );
  }

  public deleteComment(id: string): Observable<null> {
    return this.httpClient.delete<null>(`${this.commentsUrl}/${id}`);
  }
}
